var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIconPictureInPicture = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.5 2C21.8807 2 23 3.11929 23 4.5V19.5C23 20.8807 21.8807 22 20.5 22H3.5C2.11929 22 1 20.8807 1 19.5V4.5C1 3.11929 2.11929 2 3.5 2H20.5ZM20.5 4H3.5C3.22386 4 3 4.22386 3 4.5V19.5C3 19.7761 3.22386 20 3.5 20H20.5C20.7761 20 21 19.7761 21 19.5V4.5C21 4.22386 20.7761 4 20.5 4ZM19 13C19.5523 13 20 13.4477 20 14V18C20 18.5523 19.5523 19 19 19H13C12.4477 19 12 18.5523 12 18V14C12 13.4477 12.4477 13 13 13H19Z",
    fill: "currentColor"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIconPictureInPicture);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "media/IconPictureInPicture.233215f8b9a0913597c187d989ccc7d9.svg";